precision highp float;

float random(in vec2 st);
float noise2d(in vec2 st);
float noise4d(in vec4 st);

uniform float uTime;

varying vec2 vUv; // [0, 1]

const float PI = 3.14159;

varying vec3 vPosition;
uniform vec3 uIntersectPosition;

// const float LIGHT_RADIUS = 0.5;
const float LIGHT_UNDERWATER_FACTOR = 1.3;
const float LIGHT_RADIUS = 0.5 * LIGHT_UNDERWATER_FACTOR;

const vec4 POND_BLUE = vec4(0.03529411764705882, 0.20392156862745098, 0.19607843137254902, 1.0);

const vec4 SOFT_RED = vec4(.1, .02, 0.0, 1.0);
const vec4 BLACK = vec4(0.0, 0.0, 0.0, 1.0);
const vec4 SOFT_LIGHT_RED = vec4(1.0, .8, 0.8, 1.0);
const vec4 RED_JAPAN = vec4(0.737, 0., 0.176, 1.0);
const vec4 WHITE = vec4(0.9, 0.9, 0.9, 1.0);
const vec4 LIGHT_COLOR = RED_JAPAN;

void main() {
    gl_FragColor = vec4(vUv, 1.0, 1.0);

    float isPointer = sqrt(pow(vPosition.x - uIntersectPosition.x, 2.0) + pow(vPosition.z - uIntersectPosition.z, 2.0));
    // float isPointer = sqrt(pow(vPosition.x - uIntersectPosition.x, 2.0));
    isPointer = step(LIGHT_RADIUS, isPointer);
    // isPointer = smoothstep(LIGHT_RADIUS - 0.2, LIGHT_RADIUS, isPointer);

    gl_FragColor = LIGHT_COLOR;

    gl_FragColor.w = (1.0 - isPointer);

    if(isPointer >= 1.0) {
        discard;
    }

}
